export default "__VITE_ASSET__5d1e0a6f__"